import { useState } from 'react'
import { Button, TextField } from '@material-ui/core'
import { Box, CircularProgress, FormControl, Grid } from '@mui/material'
import { useCFDIFinderContainerContext } from 'containers/Invoices/NewCFDI/CFDIFinderContainer/CFDIFinderContainer'

const CFDIFinderSearch = () => {
  const { cfdisLoading, updateCFDIFinderState } =
    useCFDIFinderContainerContext()

  const [searchValue, setSearchValue] = useState('')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  const submitValue = () =>
    updateCFDIFinderState(draft => {
      draft.search = searchValue
    })

  const handleEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
    e.key === 'Enter' && submitValue()
  }

  return (
    <Box marginTop={8} className="cfdi-finder-search">
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={4}>
          <FormControl fullWidth>
            <TextField
              placeholder="Buscar por Folio, Serie, UUID o Razón Social."
              label="Buscar"
              InputLabelProps={{
                shrink: true,
              }}
              value={searchValue}
              onChange={handleChange}
              onKeyUp={handleEnter}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="outlined"
            color="secondary"
            disabled={cfdisLoading}
            onClick={submitValue}>
            {cfdisLoading ? <CircularProgress size={24} /> : 'Buscar'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default CFDIFinderSearch
